import { render, staticRenderFns } from "./comDetail.vue?vue&type=template&id=8a5cfa5c&scoped=true&"
import script from "./comDetail.vue?vue&type=script&lang=js&"
export * from "./comDetail.vue?vue&type=script&lang=js&"
import style0 from "./comDetail.vue?vue&type=style&index=0&id=8a5cfa5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5cfa5c",
  null
  
)

export default component.exports